<template>
  <div class="window" :style="{'paddingTop':statusBar + 'rem'}">
    <Header title="页面异常测试" :back="true" right />
    <div class="windowmain">
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(302)">302异常</button>
        <button class="btn2" color="#2A7EFC" @click="submit(403)">403异常</button>
      </div>
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(404)">404异常</button>
        <button class="btn2" color="#2A7EFC" @click="submit(500)">500异常</button>
      </div>
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(502)">502异常</button>
        <button class="btn2" color="#F8F8F8" @click="submit(704)">模拟扫码请求</button>
      </div>
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(700)">调起登录页面</button>
        <button class="btn2" color="#F8F8F8" @click="submit(701)">调起应用界面</button>
      </div>
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(702)">模拟session过期</button>
        <button class="btn2" color="#F8F8F8" @click="submit(703)">模拟登录过期</button>
      </div>
    </div>
  </div>
</template>

<script>
import { RadioGroup, Radio, Field } from "vant";
import Header from "@/components/Header";
export default {
  name: "home",
  /**
   * 初始化数据
   */
  data() {
    return {
      radio: "1",
      waybill: "",
      declareAtCustoms: "",
      transport: "",
      flight: "",
      container: "",
      backormoren: true,
      statusBar: 0
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
  },
  /**
   * 方法
   */
  methods: {
    setCookie:function(c_name, value, expire) {
      var date = new Date();
      date.setSeconds(date.getSeconds() + expire);
      document.cookie =
        c_name + "=" + escape(value) + "; expires=" + date.toGMTString();
    },
    // 读取cookie
    getCookie:function(c_name) {
      if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) c_end = document.cookie.length;
          return unescape(document.cookie.substring(c_start, c_end));
        }
      }
      return "";
    },

    deleteCookie:function(c_name) {
      this.setCookie(c_name, this.getCookie(c_name), -10000);
    },

    submit(val) {
      if (val === 403) {
        window.location.href = `${window.location.origin}` + "/desk/test/403";
      } else if (val === 404) {
        window.location.href = `${window.location.origin}` + "/desk/test/404";
      } else if (val === 500) {
        window.location.href = `${window.location.origin}` + "/desk/test/500";
      } else if (val === 302) {
        window.location.href = `${window.location.origin}` + "/desk/test/302";
      } else if (val === 502) {
        window.location.href = `${window.location.origin}` + "/desk/test/502";
      } else if (val === 700) {
        window.location.href =
          `${window.location.origin}` +
          "/cas/login?service=https%3A%2F%2Fapptest.singlewindow.cn%2Fzsdyckserver%2Fmyapp%2Fdist%2F%23%2Ftest%2FhtmlTest";
      } else if (val === 701) {
        window.location.href =
          `${window.location.origin}` + "/masserver/swapp/dist/#/licence";
      } else if (val === 702) {
        //window.location.href = `${window.location.origin}`+'/zsdyckserver/j_spring_cas_security_logout?clientUrl=https%3A%2F%2Fapptest.singlewindow.cn%2Fzsdyckserver%2Fsw%2FgetMenusJsonByMenuId%3Fmenu_id%3Ddec001';
        var exp = new Date();
        exp.setTime(exp.getTime() - 120 * 60 * 1000);
        document.cookie =
          // "JSESSIONID=123456;expires=" +
          // exp.toGMTString() +
          // "; Path=/; HttpOnly";
        this.deleteCookie("JSESSIONID");
        this.$toast("session修改成功！");
      } else if (val === 703) {
        window.location.href =
          `${window.location.origin}` +
          "/zsdyckserver/sw_logout/logout?service=https://apptest.singlewindow.cn/zsdyckserver/myapp/dist/";
      } else if (val === 704) {
        window.location.href =
          `${window.location.origin}` + "/zsdyckserver/qrcode/init";
      }
    }
  },
  beforeDestroy() {
    if (this.backormoren) {
      this.$tool.beforeDestroy(1);
    }
  },
  components: {
    Header,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Field.name]: Field
  }
};
</script>

<style scoped lang="scss">
.window {
  width: 100%;
  padding-top: 45px;
  .windowmain {
    background: #fff;
    overflow: auto;
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 22px;
      .btn1 {
        background: #f8f8f8;
        border: 1px solid $lineColor;
        border-radius: 4px;
        width: 119px;
        height: 44px;
        font-size: 17px;
        color: $fontColor;
      }
      .btn2 {
        background: $themColor2;
        border: 1px solid $lineColor;
        border-radius: 4px;
        width: 119px;
        height: 44px;
        color: #fff;
        font-size: 17px;
        margin-left: 60px;
      }
    }
  }
}
</style>